<template>
  <div>
    <vuescroll>
    <header class="header">
      <div ref="banner">
        <banner @image-loaded="handleResize" :bannerUrl="clientSettings.banner" />
      </div>
      <!-- Navbar-->
      <nav-bar v-if="isFixed" />
      <div ref="navbar" :class="{ 'fixed-header': isFixed }">
        <nav-bar class="nav-bar" />
      </div>
      <!-- /Navbar -->
      <div id="cart_notification" class="d-none justify-content-center align-items-center">
        <p></p>
      </div>
    </header>
    <div class="content">
      <menu-list :categories="filteredProducts" />
      <app-footer />
      <cart-bar v-if="Object.keys(cartProducts).length && !isModalShown" @show-cart="showCart()" />
      <vue-modaltor :bg-panel="'transparent'" @hide="isShow = false" :bg-overlay="'rgba(43,46,54,.6)!important'" :visible="isShow" :close-scroll="true">
        <cart @hide="hideCart" @submit-order="createNewOrder($event)" @update-order="updateExistedOrder($event)" />
      </vue-modaltor>

      <!-- <modal
        @before-close="isModalShown = false"
        @before-open="isModalShown = true"
        name="cart"
        :scrollable="true"
        :adaptive="true"
        :height="'auto'"
        class="n-modal">
        <cart @hide="hideCart" @submit-order="createNewOrder($event)" @update-order="updateExistedOrder($event)" />
      </modal> -->
    </div>
    </vuescroll>
  </div>
</template>

<script>
  import language from '../../mixins/translate'
  import {
    mapState,
    mapActions
  } from 'vuex'

  import Banner from '../../components/Banner'
  import NavBar from '../../components/NavBar'
  import MenuList from '../../components/MenuList'
  import Footer from '../../components/Footer'
  import CartBar from '../../components/CartBar'
  import Cart from '../../components/Cart'

  export default {
    mixins: [language],
    components: {
      Banner,
      NavBar,
      MenuList,
      CartBar,
      Cart,
      'app-footer': Footer
    },

    computed: {
      ...mapState('settings', ['isTable', 'clientSettings', 'tableNumber']),
      ...mapState('products', ['products', 'categories', 'filter']),
      ...mapState('cart', ['cartProducts', 'submittedOrder']),
      filteredProducts() {
        if (this.filter) {
          return [this.filter];
        }
        let categoriesProducts = [...this.categories];
        categoriesProducts = categoriesProducts.map((category) => {
          category.products = this.products.filter(product => {
            const itemCategoriesIds = product.categories.map(cat => cat.id);
            return !!itemCategoriesIds.includes(category.id);
          });
          return category
        });
        return categoriesProducts;
      },
    },
    data() {
      return {
        isFixed: false,
        isShow: false,
        thresHoldHeight: 0,
        isModalShown: false,
      }
    },
    mounted() {
      // this.handleResize();
      window.addEventListener('scroll', this.handleResize)
    },
    methods: {
      ...mapActions('cart', ['requestTableOrder', 'requestOnlineOrder', 'updateOrder', 'emptyCard']),
      handleResize() {
        if (this.$refs['banner'] && window.scrollY >= this.$refs['banner'].clientHeight + 7) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
      },
      updateFixedStatus(data) {
        this.isFixed = data
      },
      showCart() {
        this.isShow = true;
        // this.$modal.show('cart');
      },
      hideCart() {
        // this.$modal.hide('cart');
      },
      createNewOrder(form) {
        const products = Object.keys(this.cartProducts).map(key => ({
          product_id: this.cartProducts[key].id,
          quantity: this.cartProducts[key].count
        }))

        if (this.isTable) {
          return this.createTableOrder(form, products)
        }

        return this.createOnlineOrder(form, products)
      },
      async updateExistedOrder({
        note
      }) {
        const products = Object.keys(this.cartProducts).map(key => ({
          product_id: this.cartProducts[key].id,
          quantity: this.cartProducts[key].count
        }))

        const payload = {
          note,
          products,
          table_id: this.tableNumber
        };

        await this.updateOrder({
          payload,
          uuid: this.submittedOrder.uuid
        })

        this.$router.push({
          name: 'order',
          params: {
            id: this.submittedOrder.uuid
          }
        })
      },
      async createTableOrder({
        note
      }, products) {
        const payload = {
          note,
          products,
          table_id: this.tableNumber
        };

        await this.requestTableOrder(payload)

        this.$router.push({
          name: 'order',
          params: {
            id: this.submittedOrder.uuid
          }
        })
      },
      async createOnlineOrder({
        note,
        address,
        phone
      }, products) {
        await this.requestOnlineOrder({
          note,
          address,
          phone,
          products
        })
        this.emptyCard(null)
        this.$router.push({
          name: 'order',
          params: {
            id: this.submittedOrder.uuid
          }
        })
      }
    },
  }
</script>

<style lans="less">
.fixed-header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 101;
  background: white;
}

.modal-vue-wrapper {
  z-index: 2000 !important;
  height: 100% !important;
}

.modal-vue-overlay,
.v--modal-overlay {
  height: 100% !important;
}

.modal-vue-panel {
  width: 90% !important;
}

.modal-vue--content {
  padding: 24px 0 !important;
}

.modal-vue-panel {
  box-shadow: none !important;
}
.modal-vue-panel::-webkit-scrollbar-track {
  display: none !important;
}
.modal-vue-panel::-webkit-scrollbar {
  display: none !important;
}
.modal-vue-panel::-webkit-scrollbar-thumb {
  display: none !important;
}

</style>